<div class="movies-grid mb-8 mb-5">
    <h2 class="text-white font_CinematecaBlack fs-4 ml-3 ml-lg-5" [ngClass]="{'title-centered': felixoliver}">{{title}}
    </h2>

    <div class="grid px-3 px-lg-5" [ngClass]="{'category-border': felixoliver}">
        <div class="row grilla animate__animated animate__fadeIn" *ngIf="!felixoliver">
            <div class="col col-12 col-md-6 col-lg-4 col-xl-3 col-xxl-25" *ngFor="let movie of movies">
                <div class="card cardy mb-3">
                    <app-ui-movie class="movie-item" [movie]="movie"></app-ui-movie>
                </div>
            </div>
        </div>

        <div class="row grilla animate__animated animate__fadeIn" *ngIf="felixoliver">
            <div class="col col-12 col-md-6 col-lg-4 col-xl-3 col-fo" *ngFor="let movie of movies">
                <div class="card card-fo">
                    <app-ui-movie-alternative class="movie-item" [movie]="movie"></app-ui-movie-alternative>
                </div>
            </div>
        </div>

    </div>



</div>